const radardata = [
    {
        "taste": "fruity",
        "chardonay": 100,
        "carmenere": 50,
        "syrah": 78
    },
    {
        "taste": "bitter",
        "chardonay": 117,
        "carmenere": 72,
        "syrah": 65
    },
    {
        "taste": "heavy",
        "chardonay": 41,
        "carmenere": 36,
        "syrah": 48
    },
    {
        "taste": "strong",
        "chardonay": 53,
        "carmenere": 90,
        "syrah": 33
    },
    {
        "taste": "sunny",
        "chardonay": 38,
        "carmenere": 111,
        "syrah": 59
    }
]
export default radardata;